import { useTranslate } from "@lobby/ocb-intl";
import type { SuccessEventPayload } from "../../lib";
import { Dialog, type IDialogProps } from "../dialog";
import { Icon } from "../icons";

interface ISuccessModalProps extends IDialogProps {
  payload: SuccessEventPayload;
}

export function SuccessModal({ payload }: ISuccessModalProps) {
  const { $t } = useTranslate();

  const title = $t({ defaultMessage: "success" });

  return (
    <Dialog type="success" closable={false}>
      <Dialog.Title>
        <Icon name="successSign" className="text-[2.5rem]" />
        <div>{title}</div>
      </Dialog.Title>
      <Dialog.Message>{payload.message}</Dialog.Message>
    </Dialog>
  );
}
